import { render, staticRenderFns } from "./ProdutosOcorrencia.vue?vue&type=template&id=fb0064b8&scoped=true"
import script from "./ProdutosOcorrencia.vue?vue&type=script&lang=js"
export * from "./ProdutosOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./ProdutosOcorrencia.vue?vue&type=style&index=0&id=fb0064b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0064b8",
  null
  
)

export default component.exports